import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { connect } from 'react-redux';
import { Grid } from '@material-ui/core';
import { createStructuredSelector } from 'reselect';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';
import { sanlamVeryDarkBlue } from 'Material-UI/colors';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import MyRequests from 'containers/AmcDetailsPage/FollowUpMyRequestsTab/MyRequests';
import {
  StyledtBlocWrapper,
  SizedSmallSectionHeader,
} from 'containers/AmcDetailsPage/FollowUpMyRequestsTab/styles';
import { translate } from 'helpers/intl';
import messages from 'containers/AmcDetailsPage/messages';

const FollowUpMyRequestsTab = (props: { intl: IntlShape }) => {
  return (
    <GaLoadHOC
      category={EVENT_CATEGORIES.AMC_DETAILS}
      label="Suivi de mes demandes_Tab 2_Suivi de mes demandes"
    >
      <StyledtBlocWrapper height="auto">
        <Grid item>
          <SizedSmallSectionHeader color={sanlamVeryDarkBlue} weight="bold">
            {translate({ ...messages.followUpMyRequests }, props)}
          </SizedSmallSectionHeader>
        </Grid>
        <MyRequests />
      </StyledtBlocWrapper>
    </GaLoadHOC>
  );
};
const mapStateToProps = createStructuredSelector<any, {}>({});

const mapDispatchToProps = {};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(FollowUpMyRequestsTab));
